import React, { useEffect, useState } from "react";
import ContentHeading from "../../../components/layout/content/ContentHeading";
import { useDispatch } from "react-redux";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { routeName } from "../../../routes/routeName";
import {
  ButtonOutlined,
  ButtonPrimary,
} from "../../../components/button/ButtonCustoms";
import NavigateListCustom from "../../../components/navigation/NavigationListCustom";
import { Typography } from "@mui/material";
import FormComponent from "../../../components/gernerateForm/FormComponent";
import generateFormLeaveType from "./form/dataFormGenerate.data";
import { alertError, alertSuccess } from "../../../components/alert/swal";
import { leaveTypeApi } from "../../../api/leave-type/leave-type.api";
import { EmployeeApi } from "../../../api/employee/employee.api";
import { useTranslation } from "react-i18next";

type Props = {};

const ManageLeaveTypeCreate: React.FC<Props> = (props: Props) => {
  const { t } = useTranslation();
  const navigate: NavigateFunction = useNavigate();
  const dispatch = useDispatch();

  const [inputValueFormStudent, setInputValueFormStudent] = useState<any>({
    information: {
      leave_type_name: "",
      auditor_empmloyee_id: "",
      auditor_empmloyee_position: "",
      approve_empmloyee_id: "",
      approve_empmloyee_position: "",
      leave_type_form_template: "",
      leave_days_across_years: 0,
      category: "",
    },
  });

  const [isValidateForm, setIsValidateForm] = useState(false);

  const validateForm = (formData: any, formConfig: any) => {
    const errors: any = {};

    formConfig.forEach((field: any) => {
      if (field.isRequired && formData[field.section][field.name] === "") {
        errors[field.name] = `${field.label} is required`;
      }
    });

    return errors;
  };

  // const handleSubmit = (dataBody: any) => {
  //   if (dataBody) {
  //     const errors = validateForm(inputValueFormStudent, generateFormLeaveType);

  //     if (Object.keys(errors).length > 0) {
  //       setIsValidateForm(true);
  //     } else {
  //       setIsValidateForm(false);
  //       alertSuccess(
  //         "เพิ่มรูปแบบการลา",
  //         "เพิ่มรูปแบบการลา เรียบร้อยแล้ว",
  //         undefined,
  //         () => {
  //           navigate(routeName.cms.ManageLeaveType + `/1/update`);
  //         }
  //       );
  //     }
  //   }
  // };

  const handleSubmit = async (dataBody: any) => {
    const body = {
      id_leave_form: dataBody.leave_type_form_template,
      leave_type_name: dataBody.leave_type_name,
      is_accumulate: dataBody.leave_days_across_years,
      id_employee_inspector: dataBody.auditor_empmloyee_id?.value,
      id_employee_approve: dataBody.approve_empmloyee_id?.value,
      // ส่ง category เฉพาะเมื่อเลือกไว้ (รูปแบบฟอร์มอื่นจะเป็น "" -> null)
      category: dataBody.category || null,
      status: "active",
    };

    const errors = validateForm(inputValueFormStudent, generateFormLeaveType);

    if (Object.keys(errors).length > 0) {
      setIsValidateForm(true);
    } else {
      await leaveTypeApi
        .createLeaveType(body)
        .then((res) => {
          if (res.status < 300) {
            dispatch(unsetLoading());
            alertSuccess(
              t("เพิ่มรูปแบบการลา"),
              t("เพิ่มรูปแบบการลา เรียบร้อยแล้ว"),
              undefined,
              () => {
                dispatch(unsetLoading());
                navigate(
                  routeName.cms.ManageLeaveType +
                    `/${res.data.data?.id_leave_type}/update`
                );
              }
            );
          }
        })
        .catch(() => {
          alertError(t("เพิ่มรูปแบบการลา ไม่สำเร็จ"));
        })
        .finally(() => {
          dispatch(unsetLoading());
        });
    }
  };

  useEffect(() => {
    dispatch(setLoading());
    setTimeout(() => {
      dispatch(unsetLoading());
    }, 500);
  }, []);

  const getPositionEmployee = async (
    id: number,
    field: "approve_empmloyee_position" | "auditor_empmloyee_position"
  ) => {
    try {
      const res = await EmployeeApi.getOne(id);
      const data = res.data;

      setInputValueFormStudent((prev: any) => ({
        information: {
          ...prev.information,
          [field]:
            data.status < 300
              ? data.data.work_history?.position_name ?? ""
              : "",
        },
      }));
    } catch (error) {
      setInputValueFormStudent((prev: any) => ({
        information: {
          ...prev.information,
          [field]: "",
        },
      }));
    }
  };

  useEffect(() => {
    const auditorId =
      inputValueFormStudent.information.auditor_empmloyee_id?.value;
    if (auditorId) {
      getPositionEmployee(auditorId, "auditor_empmloyee_position");
    }
  }, [inputValueFormStudent.information.auditor_empmloyee_id?.value]);

  useEffect(() => {
    const approveId =
      inputValueFormStudent.information.approve_empmloyee_id?.value;
    if (approveId) {
      getPositionEmployee(approveId, "approve_empmloyee_position");
    }
  }, [inputValueFormStudent.information.approve_empmloyee_id?.value]);

  return (
    <div className="h-auto">
      {/* breadcrumbs */}
      <NavigateListCustom
        navigateData={[
          {
            name: t("จัดการรูปแบบการลา"),
            key: "1",
            pathName: routeName.cms.ManageLeaveType,
          },
          {
            name: t("เพิ่มรูปแบบการลา"),
            key: "2",
            pathName: routeName.cms.ManageLeaveTypeCreate,
          },
        ]}
      />

      {/* header */}
      <section className="my-4">
        <Typography variant="h3">{t("เพิ่มรูปแบบการลา")}</Typography>
      </section>

      <section className="w-full mt-10">
        <FormComponent
          formGenerate={generateFormLeaveType}
          inputValue={inputValueFormStudent}
          setInputValue={setInputValueFormStudent}
          handleCheckValid={isValidateForm}
          isCanEdit={true}
          permission={"admin"}
        />
      </section>

      <section className="col-span-12 flex items-center justify-center gap-4 my-4">
        <ButtonOutlined
          onClick={() => {
            navigate(routeName.cms.ManageLeaveType);
          }}
          buttonName={t("ย้อนกลับ")}
          btnProps={{
            width: "150px",
          }}
        />

        <ButtonPrimary
          onClick={() => {
            handleSubmit(inputValueFormStudent.information);
          }}
          mode="success"
          buttonName={t("ยืนยัน")}
          btnProps={{
            width: "150px",
          }}
        />
      </section>
    </div>
  );
};

export default ManageLeaveTypeCreate;
